import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../types';
import { storeResources } from '../resources';
import { LOCAL_STORAGE_IS_NEW_UI } from '../../constants/storage';

interface InitialState {
  isNewUI: boolean;
}

const getInitialUIState = (): boolean => {
  const stored = localStorage.getItem(LOCAL_STORAGE_IS_NEW_UI);
  return !stored ? false : stored === 'true';
};

const initialState: InitialState = {
  isNewUI: getInitialUIState(),
};

const uiModeSlice = createSlice({
  name: storeResources.UI_MODE,
  initialState,
  reducers: {
    setUIMode: (state: InitialState, action: { payload: boolean }) => {
      state.isNewUI = action.payload;
      localStorage.setItem(LOCAL_STORAGE_IS_NEW_UI, String(action.payload));
    },
  },
});

export default uiModeSlice.reducer;

export const UIModeSelector = (state: RootState): boolean => state[storeResources.UI_MODE].isNewUI;

export const { setUIMode } = uiModeSlice.actions;
